interface LeftoverAmountProps {
  amount: string;
}

const LeftoverAmount: React.FC<LeftoverAmountProps> = ({ amount }) => {
  return (
    <div className="mt-2">
      <span className="font-grotesque font-medium text-teal-01">
        {amount} remaining to pay with your card
      </span>
    </div>
  );
};

export default LeftoverAmount;
